import React from 'react'
import { StyledNumberSelectForm, StyledNumberSelectFormProps } from './styled'

export const NumberSelectForm: React.FC<StyledNumberSelectFormProps> = (props: StyledNumberSelectFormProps) => {
  return (
    <StyledNumberSelectForm {...props} />
  )
}
